export default defineNuxtRouteMiddleware(async () => {
  const appConfig = useAppConfig();

  if (appConfig.loadFeatures) {
    const featuresConfig = await getCachedFeatureFlags();

    if (featuresConfig) {
      if (import.meta.dev) {
        Object.assign(appConfig.features, featuresConfig);
      } else {
        appConfig.features = featuresConfig;
      }
    }
  }
});
